import { useHover } from '@seiue/util'
import { getTheme } from 'packages/theme'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

import { iconParkMap, IconParkSVGWrapperProps } from './types'

const theme = getTheme()

export const IconParkComponent: React.FC<IconParkSVGWrapperProps> = (props) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const root = useRef<SVGSVGElement>(null)
  const isHover = useHover(wrapperRef as any)
  const {
    name,
    size = '16px',
    width,
    height,
    spin,
    rtl,
    color = theme.text._2,
    hoverColor,
    fill,
    stroke,
    className,
    text,
    textMarginLeft = 3,
    wrapperStyle,
    ...rest
  } = props
  const _width = width || size
  const _height = height || size
  const _fill =
    isHover && hoverColor ? hoverColor : fill || color || 'currentColor'

  const _stroke =
    isHover && hoverColor ? hoverColor : stroke || color || 'currentColor'

  useEffect(() => {
    if (!_fill) {
      ;(root.current as SVGSVGElement)
        ?.querySelectorAll('[data-follow-fill]')
        .forEach((item) => {
          item.setAttribute('fill', item.getAttribute('data-follow-fill') || '')
        })
    }
    if (!_stroke) {
      ;(root.current as SVGSVGElement)
        ?.querySelectorAll('[data-follow-stroke]')
        .forEach((item) => {
          item.setAttribute(
            'stroke',
            item.getAttribute('data-follow-stroke') || ''
          )
        })
    }
  }, [stroke, color, fill])

  const Component = iconParkMap[name]
  return (
    <Wrapper
      ref={wrapperRef}
      className="icon-wrapper"
      style={wrapperStyle}
    >
      <Component
        _width={_width}
        _height={_height}
        _fill={_fill}
        spin={spin}
        rtl={rtl}
        className={className}
        {...rest}
        ref={root}
      />
      {text ? (
        <span
          style={{
            fontSize: `${typeof size === 'number' ? size + 'px' : size}`,
            color: _fill,
            marginLeft:
              typeof textMarginLeft === 'number'
                ? textMarginLeft + 'px'
                : textMarginLeft,
          }}
        >
          {props.text}
        </span>
      ) : null}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`
